import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabBase } from '@core/base/tab.base';

@Component({
  selector: 'app-vehicle-mileage-history-tab',
  templateUrl: './vehicle-mileage-history-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VehicleMileageHistoryTabComponent extends TabBase {
  constructor() {
    super(inject(ActivatedRoute).parent!);
  }
}
